export default {
  methods: {
    async createNewFileFromUrl (documentID, url) {
      if (!url) return null

      try {
        const isS3StorageUrl = url.includes('backblazeb2.com')
        const response = await fetch(url, {
          cache: isS3StorageUrl ? 'no-store' : 'default',
          credentials: isS3StorageUrl ? 'omit' : 'same-origin',
          mode: isS3StorageUrl ? 'cors' : 'same-origin'
        })
        if (!response.ok) return null

        const blob = await response.blob()
        const extension = blob.type ? blob.type.split('/').pop() : 'file'
        const name = `${documentID}.${extension}`

        return new File([blob], name, { type: blob.type || 'application/octet-stream' })
      } catch (error) {
        return null
      }
    }
  }
}
